export default __webpack_public_path__ + "static/media/img-lp-heng.2e7598f5.svg";